/** sessionStorage key for return path after login. */
export const POST_LOGIN_REDIRECT_STORAGE_KEY = 'frontendPostLoginPath';

